import Api from '../../api/api'
import {
    setToken,
    setUisId,
    setIntegration,
    setLogin,
    setAuth,
    toggleExpansionPanel,
    setIdSalon
} from './setting.action'

export const AUTH_CONST = {
    SET_INPUT_TOKEN:"setInputToken",
    SET_STATUS_AUTH:"setStatusAuth",
    STATUS_AUTH_WAIT:"statusAuthWait",
    ERR_DEFAULT: "errDefault",  
    ERR_NETWORK: "errNetwork", 
    ERR_HIDE: "errHide",
    ERR_204: "err204",  
    ERR_400: "err400",
    ERR_401: "err401",
    ERR_403: "err403",
    ERR_418: "err418",
    SET_SERVICE: "SET_SERVICE",
}

export function setInputToken(text){
    return{
        type: AUTH_CONST.SET_INPUT_TOKEN,
        payload: text,
    }
}

// export function setInputPass(text){
//     return{
//         type: AUTH_CONST.SET_INPUT_PASS,
//         payload: text,
//     }
// }

export function select_service(text){
    return{
        type: AUTH_CONST.SET_SERVICE,
        payload: text,
    }
}

export function auth(token, service){
    return dispatch => {
        dispatch({
            type: AUTH_CONST.STATUS_AUTH_WAIT,
            payload: true,
        })
        Api.auth(token, service)
        .then(
            (result)=>{
                dispatch({
                    type: AUTH_CONST.STATUS_AUTH_WAIT,
                    payload: false,
                });
                
                switch (result.status){
                    case 200:
                        dispatch({
                            type: AUTH_CONST.ERR_HIDE
                        });
                        dispatch({
                            type: result.data.is_auth? AUTH_CONST.SET_STATUS_AUTH: AUTH_CONST.ERR_DEFAULT,
                            payload: result.data.is_auth
                        });
                        dispatch(setLogin(result.data.login_crm));
                        // dispatch(setCallapiStatus(result.data.optionsUis.callapi));
                        // dispatch(setNotificationStatus(result.data.optionsUis.notification));
                        // dispatch(toggleExpansionPanel(!(result.data.optionsUis.callapi && result.data.optionsUis.notification && result.data.optionsUis.dataapi)));
                        dispatch(setIdSalon(result.data.id_crm));
                        dispatch(setToken(result.data.token_crm));
                        dispatch(setUisId(result.data.app_id, result.data.customer_id));
                        dispatch(setIntegration(result.data.is_integration));
                        // dispatch(setAuth(user, pass)); передать авторизацию в основную форму
                        return
                    case 204:
                        dispatch({
                            type: AUTH_CONST.ERR_204,
                            payload: true,
                        });
                        return
                    default:
                        dispatch({
                            type: AUTH_CONST.ERR_NETWORK,
                            payload: result.statusText + " " + result.status,
                        });
                }
            }
        )
        .catch(
            (err)=>{
                dispatch({
                    type: AUTH_CONST.STATUS_AUTH_WAIT,
                    payload: false,
                });
                switch (err.request.status){
                    case 400:
                        dispatch({
                            type: AUTH_CONST.ERR_400,
                            payload: true,
                        });
                        return
                    case 401:
                        dispatch({
                            type: AUTH_CONST.ERR_401,
                            payload: true,
                        });
                        return
                    case 403:
                        dispatch({
                            type: AUTH_CONST.ERR_403,
                            payload: true,
                        });
                        return
                    case 418:
                        dispatch({
                            type: AUTH_CONST.ERR_418,
                            payload: err.response.data.err_component,
                        });
                        return
                    default:
                        dispatch({
                            type: AUTH_CONST.ERR_NETWORK,
                            payload: err.message,
                        });
                }

            }
        )
    }
}
export function logout(){
    return{
        type: AUTH_CONST.SET_STATUS_AUTH,
        payload: false,
    }
}
export function isLogin(){
    
}
